<template>
    <div class="news-detail">
        <img style="width: 100%" src="../assets/images/v2_s3sqsj.jpg" alt="">
        <div v-if="id === 1">
            <div class="news-title">
                平常的调研，不平常的部署
            </div>
            <div class="news-text">
                <div class="news-img">
                    <img style="height: 100%;object-fit: contain;" src="@/assets/images/img_2.png" alt="">
                </div>
                <div>
                    <span>2023年12月14日，应中南大学邹滨教授邀请，湖南省生态环境厅环境监测处处长金杰坤、湖南省生态环境监测中心主任余涛、湖南省生态环境厅环境监测处副处长丁华、湖南 省生态环境监测中心生态部部长易敏、湖南省生态环境监测中心大气部部长郭卉等一行5人参加了中南大学“天空地一体化大气污染热点网格技术”成果应用总结交流会。会上，邹滨教授首先代表学校、科研团队对省厅领导能在百忙之中拨冗莅临指导工作表示热烈的欢迎。作为中南大学技术成果转化指定单位，中南经纬承办了本次会议活动。</span>
                </div>

                <div>
                    <span>邹滨教授先后汇报了中南大学遥感学科的发展历程与所处的学术地位、遥感技术在生态环境保护方面能做什么贡献、遥感技术如何赋能生态环境保护、遥感技术在水土气声污染等方面的系列落地实践和所获得的荣誉、以及对未来技术熟成推广应用的一些思考和规划等。在听取完邹滨教授利用遥感创新技术在水、土、气、声等污染防治方面取得的一系列成果、尤其是了解到中南大学“高值热点网格技术”赋能长沙市生态环境监测中心并荣膺全国性“示范案例”称号后，金杰坤处长提出：省环境污染防治工作已进入精细化管理时代，中南大学掌握的遥感创新技术在精准溯源、精准施策、精准管控、精准评估、精准治理方面有独特优势，理应优先服务于湖南家乡人民、造福于湖湘大地；同时希望邹滨教授及其团队要与省厅各级进一步开展项目合作，为美丽湖南建设做更大的贡献。随后，余涛主任紧接着提出：环保主管部门要有主动拥抱新技术的思维，在对待新技术、新手段的出现要保持少质疑、多接纳的态度；并表示，主管部门要多了解科研目前有什么新技术、科研要了解主管部门平常在想什么；他还提出下一步将推进双方在开展供需对接上要常态化，鼓励多做示范性应用。丁华副处长在谈及当前的管理平台在实测与预报方面，主要还是靠“人海”战，不能达到精准、精简、经用的效果，希望能快速加强合作；易敏部长就现有信息化平台运行中的痛点问题，提出以“购买服务”为主的需求，希望中南大学在污染监测、预警预报方面定向推送服务；郭卉部长在听取汇报后，先是提出了当前几个急需待解决的需求，并希望中南大学的遥感技术在有关水华监测、裸露地表扬尘数据提取、以及国控站点选址优化、跨界传输贡献解析方面更早发挥作用。参加本次会议的还有中南经纬环境研究院院长郑超、中南经纬环境研究院政府项目合作部部长马薏钧以及科研团队等20余人出席交流。</span>
                </div>

            </div>
        </div>
        <div v-if="id == 2">
            <div class="news-title">
                事关重大部署，书记亲临现场主持项目验收
            </div>
            <div class="news-text">
                <div class="news-img">
                    <img style="height: 100%;object-fit: contain;" src="@/assets/images/img_4.png" alt="">
                </div>
                <div>
                    <span>2023年10月12日，应项目课题组邀请，常德市自然资源和规划局党组书记、局长宋磊，常德市自然资源和规划局副局长张辉，常德市自然资源和规划局办公室主任唐家新等领导专家一行5人，亲临省会长沙听取了“常德市碳汇监测试点”项目成果验收汇报。会上，中南大学地球科学与信息物理学院副院长、教授邹滨首先代表学校、学院、科研团队对市局班子成员亲临项目结题现场指导验收工作表达了热烈的欢迎和诚挚的问候；紧接着介绍了中南大学遥感学科的发展历程与所处的学术地位、遥感技术在自然资源规划方面能做什么贡献、遥感技术如何赋能规划建设、耕地保护、集约节约等业务发展，并简要的总结了本次试点项目的主要成果清单。作为中南大学技术成果转化指定单位，中南经纬承办了本次会议。</span>
                </div>
                <div>
                    <span>在听取完邹滨教授利用遥感创新技术在碳汇试点项目中取得的一系列可喜成果，尤其是了解到在项目经费异常紧张、项目课题组毅然选择自筹资金也要按时交付项目成果的决心后，宋磊书记代表市局对邹滨教授如此家国情怀的为家乡人民、为常德建设付出的努力与智慧表达了敬佩之情，同时对“常德市碳汇监测试点”项目成果给予了极大肯定和赞赏；随后表示：将亲自挂帅，尤其是对待在研的15个合作项目上，将举全局力量提供无缝对接与支持，要求把资金统起来、把项目立上来、把标准定下来；同时希望在与中南团队进一步的合作中，扩大“山水修复工程”+“碳-金转化”成果，争取用1年时间做成省内亮点项目；双方还就开发场景化实景三维、合作发表高水平论文、联合制定培养计划等方面达成了新的合作共识。本次项目成果验收在双方的掌声互动中完美收官，参加本次会议的还有中南经纬环境研究院院长郑超，以及科研团队等8人参与项目验收结题答辩。</span>
                </div>

            </div>
        </div>
<!--        <div v-if="id == 3">-->
<!--            <div class="news-title">-->
<!--                用真技术赢得客户信任-->
<!--            </div>-->
<!--            <div class="news-text">-->
<!--                <div class="news-img">-->
<!--                    <img style="height: 100%;object-fit: contain;" src="@/assets/images/img_3.png" alt="">-->
<!--                </div>-->
<!--                <div>-->
<!--                    <span>2023年7月12日，应中国环境监测总站邀请，我司首席科学家、中南大学地球科学与信息物理学院邹滨教授及其科研骨干成员等一行前往临湘市调研大气污染防治工作进展情况，我司研究院院长郑超应邀随同参与了本次调研交流会。</span>-->
<!--                </div>-->

<!--                <div>-->
<!--                    <span>调研队伍一行深入临湘市气象站、三湾工业园、云溪区绿色化工园、长炼石化、海螺水泥、凡泰矿业、金叶肥等几个有代表性的污染源由点及面的开展摸底工作。交流会上，临湘市副市长姚铁军给予了中南团队掌握的“大气污染高值热点网格技术”极大的肯定，临湘生态环境局分局局长李友良对该技术在大气污染精细化治理方面的应用表达了强烈的合作意愿，并提出来用3年时间实现临湘市大气污染排名稳定靠前的目标。</span>-->
<!--                </div>-->

<!--            </div>-->
<!--        </div>-->
        <div v-html="vhtml">

        </div>
    </div>
</template>

<script>
import {getNews} from "@/api/user";

export default {
  name: "NewsDetail",
  data() {
    return {
      id: 0,
      vhtml: null
    }
  },
  methods: {

  },
  mounted() {
    this.id =  this.$route.query.newsId
    getNews(this.id).then((res) => {
      console.log(res);
      this.vhtml = res.data.content
    })
    // const id = this.$route.params
  }
}
</script>

<style lang="less" scoped>
.news-detail {
  .news-title {
    font-size: 40px;
    line-height: 80px;
  }

  .news-text {
    padding: 30px;
    line-height: 40px;
    text-align: left;
    text-indent: 2em;
    font-size: 20px;

    .news-sub-title {
      text-align: left;
      font-size: 25px;
      font-weight: bold;
      padding: 20px 0;

    }
    .news-img {
      display: flex;
      flex-direction: column;
      align-items: center;
    }
  }


}

</style>